'use client'

import { create } from 'zustand'
import { readModuleFlagsCookie } from '@/shared/lib/moduleFlags'

interface ModuleFlagsState {
  /**
   * Module ids whose PostHog `module-<id>` flag doesn't evaluate to false,
   * or `null` while availability is unknown (flags not loaded yet and no
   * cookie from a previous visit) — unknown means everything is available.
   */
  availableIds: string[] | null

  setAvailableIds: (ids: string[]) => void
  isModuleAvailable: (moduleId: string) => boolean
  reset: () => void
}

/**
 * Client mirror of the module-availability cookie (see moduleFlags.ts).
 * Seeded from the cookie so a reload doesn't flash flag-hidden modules while
 * posthog-js boots; ModuleFlagsRefresher (PostHogProvider.tsx) overwrites it
 * whenever PostHog (re)loads the flags.
 */
export const useModuleFlagsStore = create<ModuleFlagsState>()((set, get) => ({
  availableIds: readModuleFlagsCookie(),

  setAvailableIds: (ids: string[]) => set({ availableIds: ids }),

  isModuleAvailable: (moduleId: string) => {
    const { availableIds } = get()
    if (availableIds == null) return true
    return availableIds.includes(moduleId)
  },

  reset: () => set({ availableIds: null }),
}))
